// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-layer-toolbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  font-size: 14px;
  align-items: center;
  pointer-events: none;
}

.map-layer-name {
  font-weight: 500;
  padding: 2px 0;
}

.map-layer-key {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(0, 0, 0, 0.3);
}

/* Thin scrollbar for WebKit browsers */
.map-layer-key::-webkit-scrollbar {
  height: 4px; /* Adjust height */
}

.map-layer-key::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.3);
}

.map-layer-key::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.key-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 10px;
  font-size: 12px;
  flex-shrink: 0; /* Prevent items from shrinking */
}

.key-item.temp-item {
  width: 270px;
}

.color-bar-container {
  display: flex;
  height: 8px;
  width: 150px;
  border-radius: 2px;
  overflow: hidden;
}

.temp-key.color-bar-container {
  width: 270px;
  height: 8px;
}

.color-bar-segment {
  flex: 1;
  height: 100%;
}

.key-labels {
  display: flex;
  width: 150px;
  justify-content: space-between;
  font-size: 10px;
  margin-top: 2px;
  position: relative;
}

/* Temperature scale labels */
.temp-key-labels {
  display: flex;
  width: 270px;
  justify-content: space-between;
  font-size: 9px;
  margin-top: 2px;
}

.temp-label {
  transform: translateX(-50%);
  position: relative;
  white-space: nowrap;
}

/* Dew point specific adjustments */
.dewpoint-key.color-bar-container {
  width: 150px;
}

.dewpoint-key + .temp-key-labels {
  width: 150px;
}

/* Temperature colors - using exact values from API documentation */
.temp-key .color-bar-segment:nth-child(1) { background-color: rgb(40,10,70); } /* -70°F */
.temp-key .color-bar-segment:nth-child(2) { background-color: rgb(80,50,130); } /* -50°F */
.temp-key .color-bar-segment:nth-child(3) { background-color: rgb(160,130,190); } /* -30°F */
.temp-key .color-bar-segment:nth-child(4) { background-color: rgb(110,0,70); } /* -10°F */
.temp-key .color-bar-segment:nth-child(5) { background-color: rgb(160,50,140); } /* 0°F */
.temp-key .color-bar-segment:nth-child(6) { background-color: rgb(205,95,200); } /* 10°F */
.temp-key .color-bar-segment:nth-child(7) { background-color: rgb(170,225,250); } /* 20°F */
.temp-key .color-bar-segment:nth-child(8) { background-color: rgb(100,125,190); } /* 30°F */
.temp-key .color-bar-segment:nth-child(9) { background-color: rgb(20,20,150); } /* 40°F */
.temp-key .color-bar-segment:nth-child(10) { background-color: rgb(115,105,100); } /* 50°F */
.temp-key .color-bar-segment:nth-child(11) { background-color: rgb(215,215,50); } /* 60°F */
.temp-key .color-bar-segment:nth-child(12) { background-color: rgb(220,150,0); } /* 70°F */
.temp-key .color-bar-segment:nth-child(13) { background-color: rgb(220,40,0); } /* 80°F */
.temp-key .color-bar-segment:nth-child(14) { background-color: rgb(150,0,0); } /* 90°F */
.temp-key .color-bar-segment:nth-child(15) { background-color: rgb(245,125,200); } /* 100°F */
.temp-key .color-bar-segment:nth-child(16) { background-color: rgb(210,210,210); } /* 110°F */
.temp-key .color-bar-segment:nth-child(17) { background-color: rgb(240,240,175); } /* 120°F */
.temp-key .color-bar-segment:nth-child(18) { background-color: rgb(255,255,255); } /* 130°F */

/* Dew Point key colors - using exact values from API documentation */
.dewpoint-key .color-bar-segment:nth-child(1) { background-color: rgb(255,175,0); } /* -40° */
.dewpoint-key .color-bar-segment:nth-child(2) { background-color: rgb(255,245,0); } /* -20° */
.dewpoint-key .color-bar-segment:nth-child(3) { background-color: rgb(215,210,55); } /* 0° */
.dewpoint-key .color-bar-segment:nth-child(4) { background-color: rgb(175,190,85); } /* 20° */
.dewpoint-key .color-bar-segment:nth-child(5) { background-color: rgb(0,255,0); } /* 40° */
.dewpoint-key .color-bar-segment:nth-child(6) { background-color: rgb(0,175,0); } /* 60° */
.dewpoint-key .color-bar-segment:nth-child(7) { background-color: rgb(0,60,0); } /* 80+° */

/* Rain key colors */
.rain-key .color-bar-segment:nth-child(1) { background-color: #63EB63; } /* Light - light green */
.rain-key .color-bar-segment:nth-child(2) { background-color: #1C9E34; } /* Light - dark green */
.rain-key .color-bar-segment:nth-child(3) { background-color: #FBEB02; } /* Light-Medium - yellow */
.rain-key .color-bar-segment:nth-child(4) { background-color: #EE6D02; } /* Medium-Heavy - orange */
.rain-key .color-bar-segment:nth-child(5) { background-color: #D20B06; } /* Heavy - red */
.rain-key .color-bar-segment:nth-child(6) { background-color: #A90503; } /* Heavy - dark red */
.rain-key .color-bar-segment:nth-child(7) { background-color: #800000; } /* Heavy - maroon */

/* Snow key colors */
.snow-key .color-bar-segment:nth-child(1) { background-color: #B7E9ED; }
.snow-key .color-bar-segment:nth-child(2) { background-color: #A5DBED; }
.snow-key .color-bar-segment:nth-child(3) { background-color: #88B6F7; }
.snow-key .color-bar-segment:nth-child(4) { background-color: #8F84F4; }
.snow-key .color-bar-segment:nth-child(5) { background-color: #A259DF; }
.snow-key .color-bar-segment:nth-child(6) { background-color: #C546C8; }
.snow-key .color-bar-segment:nth-child(7) { background-color: #E650B1; }

/* Wind speed colors - using exact values from API documentation with 10mph increments */
.wind-key .color-bar-segment:nth-child(1) { background-color: rgb(70,210,255); } /* 10 mph */
.wind-key .color-bar-segment:nth-child(2) { background-color: rgb(25,120,255); } /* 20 mph */
.wind-key .color-bar-segment:nth-child(3) { background-color: rgb(0,50,170); } /* 30 mph */
.wind-key .color-bar-segment:nth-child(4) { background-color: rgb(0,0,90); } /* 40 mph */
.wind-key .color-bar-segment:nth-child(5) { background-color: rgb(100,15,150); } /* 50 mph */
.wind-key .color-bar-segment:nth-child(6) { background-color: rgb(165,0,100); } /* 60+ mph */

/* Wind speed specific adjustments */
.wind-key.color-bar-container {
  width: 180px;
}

.wind-key + .temp-key-labels {
  width: 180px;
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  position: relative;
}

.wind-key + .temp-key-labels .temp-label {
  position: absolute;
  font-size: 9px;
  text-align: center;
  transform: translateX(-50%);
}

/* Position each label precisely */
.wind-key + .temp-key-labels .temp-label:nth-child(1) { left: 0; transform: translateX(0); }
.wind-key + .temp-key-labels .temp-label:nth-child(2) { left: 20%; transform: translateX(-50%); }
.wind-key + .temp-key-labels .temp-label:nth-child(3) { left: 40%; transform: translateX(-50%); }
.wind-key + .temp-key-labels .temp-label:nth-child(4) { left: 60%; transform: translateX(-50%); }
.wind-key + .temp-key-labels .temp-label:nth-child(5) { left: 80%; transform: translateX(-50%); }
.wind-key + .temp-key-labels .temp-label:nth-child(6) { left: 100%; transform: translateX(-100%); }

/* Adjust wind key container width for mobile */
@media (max-width: 768px) {
  .wind-key.color-bar-container,
  .wind-key + .temp-key-labels {
    width: 100%;
    max-width: 180px;
  }
}

/* UV key colors - using exact values from API documentation */
.uv-key .color-bar-segment:nth-child(1) { background-color: rgb(90,85,80); } /* 1-2 */
.uv-key .color-bar-segment:nth-child(2) { background-color: rgb(120,120,115); } /* 3 */
.uv-key .color-bar-segment:nth-child(3) { background-color: rgb(150,150,150); } /* 4 */
.uv-key .color-bar-segment:nth-child(4) { background-color: rgb(140,110,90); } /* 5 */
.uv-key .color-bar-segment:nth-child(5) { background-color: rgb(190,175,80); } /* 6 */
.uv-key .color-bar-segment:nth-child(6) { background-color: rgb(240,240,63); } /* 7 */
.uv-key .color-bar-segment:nth-child(7) { background-color: rgb(220,135,20); } /* 8 */
.uv-key .color-bar-segment:nth-child(8) { background-color: rgb(220,75,15); } /* 9 */
.uv-key .color-bar-segment:nth-child(9) { background-color: rgb(220,15,15); } /* 10 */
.uv-key .color-bar-segment:nth-child(10) { background-color: rgb(215,65,140); } /* 11 */

/* UV index specific adjustments */
.uv-key.color-bar-container {
  width: 200px;
}

.uv-key + .temp-key-labels {
  width: 200px;
  justify-content: space-between;
  padding: 0 5px;
  margin-top: 4px;
}

.uv-key + .temp-key-labels .temp-label {
  transform: translateX(-50%);
  font-size: 9px;
  text-align: center;
  position: relative;
}

.uv-key + .temp-key-labels .temp-label:first-child {
  transform: translateX(0);
}

.uv-key + .temp-key-labels .temp-label:last-child {
  transform: translateX(-100%);
}

/* Adjust UV key container width for mobile */
@media (max-width: 768px) {
  .map-layer-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .map-layer-key {
    margin-top: 5px;
    width: 100%;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 8px;
  }
  
  .key-item.temp-item {
    width: 100%;
    max-width: 270px;
  }
  
  .temp-key.color-bar-container {
    width: 100%;
    max-width: 270px;
  }
  
  .temp-key-labels {
    width: 100%;
    max-width: 270px;
    font-size: 7px;
  }
  
  .uv-key.color-bar-container,
  .uv-key + .temp-key-labels {
    width: 100%;
    max-width: 200px;
  }
}

/* Temperature scale labels positioning */
.temp-key + .temp-key-labels {
  width: 270px;
  position: relative;
  height: 16px;
  margin-top: 4px;
}

.temp-key + .temp-key-labels .temp-label {
  position: absolute;
  font-size: 9px;
  text-align: center;
  transform: translateX(-50%);
}

/* Position each temperature label precisely */
.temp-key + .temp-key-labels .temp-label:nth-child(1) { left: 0%; transform: translateX(0); } /* -70° */
.temp-key + .temp-key-labels .temp-label:nth-child(2) { left: 11.1%; transform: translateX(-50%); } /* -30° */
.temp-key + .temp-key-labels .temp-label:nth-child(3) { left: 22.2%; transform: translateX(-50%); } /* -10° */
.temp-key + .temp-key-labels .temp-label:nth-child(4) { left: 33.3%; transform: translateX(-50%); } /* 20° */
.temp-key + .temp-key-labels .temp-label:nth-child(5) { left: 44.4%; transform: translateX(-50%); } /* 40° */
.temp-key + .temp-key-labels .temp-label:nth-child(6) { left: 55.5%; transform: translateX(-50%); } /* 60° */
.temp-key + .temp-key-labels .temp-label:nth-child(7) { left: 66.6%; transform: translateX(-50%); } /* 80° */
.temp-key + .temp-key-labels .temp-label:nth-child(8) { left: 77.7%; transform: translateX(-50%); } /* 100° */
.temp-key + .temp-key-labels .temp-label:nth-child(9) { left: 100%; transform: translateX(-100%); } /* 130° */

/* Feels Like specific adjustments */
.feels-like-key.color-bar-container {
  width: 270px;
}

.feels-like-key + .temp-key-labels {
  width: 270px;
  position: relative;
  height: 16px;
  margin-top: 4px;
}

.feels-like-key + .temp-key-labels .temp-label {
  position: absolute;
  font-size: 9px;
  text-align: center;
  transform: translateX(-50%);
}

/* Position each feels like temperature label precisely */
.feels-like-key + .temp-key-labels .temp-label:nth-child(1) { left: 0%; transform: translateX(0); } /* -50° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(2) { left: 11.1%; transform: translateX(-50%); } /* -30° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(3) { left: 22.2%; transform: translateX(-50%); } /* -10° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(4) { left: 33.3%; transform: translateX(-50%); } /* 10° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(5) { left: 44.4%; transform: translateX(-50%); } /* 30° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(6) { left: 55.5%; transform: translateX(-50%); } /* 40° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(7) { left: 66.6%; transform: translateX(-50%); } /* 50° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(8) { left: 77.7%; transform: translateX(-50%); } /* 80° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(9) { left: 88.8%; transform: translateX(-50%); } /* 100° */
.feels-like-key + .temp-key-labels .temp-label:nth-child(10) { left: 100%; transform: translateX(-100%); } /* 120° */

/* Feels Like colors - using exact values from API documentation */
.feels-like-key .color-bar-segment:nth-child(1) { background-color: rgb(80,50,130); } /* -50°F */
.feels-like-key .color-bar-segment:nth-child(2) { background-color: rgb(160,130,190); } /* -30°F */
.feels-like-key .color-bar-segment:nth-child(3) { background-color: rgb(110,0,70); } /* -10°F */
.feels-like-key .color-bar-segment:nth-child(4) { background-color: rgb(205,95,200); } /* 10°F */
.feels-like-key .color-bar-segment:nth-child(5) { background-color: rgb(90,120,185); } /* 30°F */
.feels-like-key .color-bar-segment:nth-child(6) { background-color: rgb(25,30,150); } /* 40°F */
.feels-like-key .color-bar-segment:nth-child(7) { background-color: rgb(115,105,100); } /* 50°F */
.feels-like-key .color-bar-segment:nth-child(8) { background-color: rgb(0,0,0); } /* 51-79°F */
.feels-like-key .color-bar-segment:nth-child(9) { background-color: rgb(220,40,0); } /* 80°F */
.feels-like-key .color-bar-segment:nth-child(10) { background-color: rgb(245,125,200); } /* 100°F */
.feels-like-key .color-bar-segment:nth-child(11) { background-color: rgb(240,20,110); } /* 120°F */

/* Multi-key for radar display (Rain, Mix, Snow) */
.multi-key.color-bar-container {
  display: flex;
  gap: 20px;
  width: 400px;
  height: auto;
}

.multi-key-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.key-type-label {
  font-size: 10px;
  margin-bottom: 2px;
  font-weight: 500;
}

.rain-key-segment, .mix-key-segment, .snow-key-segment {
  width: 100%;
  height: 8px;
  border-radius: 2px;
}

.rain-key-segment {
  background: linear-gradient(to right, #63EB63, #1C9E34, #FBEB02, #EE6D02, #D20B06, #A90503, #800000, #D2449C, #FFFFFF);
}

.mix-key-segment {
  background: linear-gradient(to right, #FFA0CF, #D96EA3, #C04D86, #AE3370, #830D4F);
}

.snow-key-segment {
  background: linear-gradient(to right, #8AF8FF, #6ECBD4, #529FAA, #44899A, #285D68, #0D3140);
}

.intensity-labels {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 9px;
  margin-top: 2px;
}

.light-label {
  text-align: left;
}

.heavy-label {
  text-align: right;
}

.key-item.multi-item {
  width: 400px;
}

/* Adjust for mobile */
@media (max-width: 768px) {
  .multi-key.color-bar-container {
    width: 100%;
    max-width: 400px;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.3) rgba(0, 0, 0, 0.3);
    gap: 10px;
  }
  
  .multi-key.color-bar-container::-webkit-scrollbar {
    height: 4px;
  }

  .multi-key.color-bar-container::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.3);
  }

  .multi-key.color-bar-container::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }
  
  .key-item.multi-item {
    width: 100%;
    max-width: 400px;
  }
  
  .multi-key-group {
    width: 100%;
  }
}

/* Common styles for all gradient keys */
.temp-key-gradient, 
.dewpoint-key-gradient, 
.rain-key-gradient, 
.snow-key-gradient, 
.wind-key-gradient, 
.uv-key-gradient,
.feels-like-key-gradient {
  width: 100%;
  height: 8px;
  border-radius: 2px;
}

/* Temperature gradient using exact colors from API documentation */
.temp-key-gradient {
  background: linear-gradient(to right,
    rgb(40,10,70),    /* -70°F */
    rgb(80,50,130),   /* -50°F */
    rgb(160,130,190), /* -30°F */
    rgb(110,0,70),    /* -10°F */
    rgb(160,50,140),  /* 0°F */
    rgb(205,95,200),  /* 10°F */
    rgb(170,225,250), /* 20°F */
    rgb(100,125,190), /* 30°F */
    rgb(20,20,150),   /* 40°F */
    rgb(115,105,100), /* 50°F */
    rgb(215,215,50),  /* 60°F */
    rgb(220,150,0),   /* 70°F */
    rgb(220,40,0),    /* 80°F */
    rgb(150,0,0),     /* 90°F */
    rgb(245,125,200), /* 100°F */
    rgb(210,210,210), /* 110°F */
    rgb(240,240,175), /* 120°F */
    rgb(255,255,255)  /* 130°F */
  );
}

/* Dew Point gradient using exact values from API documentation */
.dewpoint-key-gradient {
  background: linear-gradient(to right,
    rgb(255,175,0),  /* -40° */
    rgb(255,245,0),  /* -20° */
    rgb(215,210,55), /* 0° */
    rgb(175,190,85), /* 20° */
    rgb(0,255,0),    /* 40° */
    rgb(0,175,0),    /* 60° */
    rgb(0,60,0)      /* 80+° */
  );
}

/* Rain key gradient */
.rain-key-gradient {
  background: linear-gradient(to right, 
    #C1E6D0, 
    #7FD67F, 
    #FFE978, 
    #FFC140, 
    #FF9A3C, 
    #FF6E3C, 
    #F55A90
  );
}

/* Snow key gradient */
.snow-key-gradient {
  background: linear-gradient(to right,
    #B7E9ED,
    #A5DBED,
    #88B6F7,
    #8F84F4,
    #A259DF,
    #C546C8,
    #E650B1
  );
}

/* Wind speed gradient using exact values from API documentation */
.wind-key-gradient {
  background: linear-gradient(to right,
    rgb(70,210,255),  /* 10 mph */
    rgb(25,120,255),  /* 20 mph */
    rgb(0,50,170),    /* 30 mph */
    rgb(0,0,90),      /* 40 mph */
    rgb(100,15,150),  /* 50 mph */
    rgb(165,0,100)    /* 60+ mph */
  );
}

/* UV key gradient using exact values from API documentation */
.uv-key-gradient {
  background: linear-gradient(to right,
    rgb(90,85,80),    /* 1-2 */
    rgb(120,120,115), /* 3 */
    rgb(150,150,150), /* 4 */
    rgb(140,110,90),  /* 5 */
    rgb(190,175,80),  /* 6 */
    rgb(240,240,63),  /* 7 */
    rgb(220,135,20),  /* 8 */
    rgb(220,75,15),   /* 9 */
    rgb(220,15,15),   /* 10 */
    rgb(215,65,140)   /* 11 */
  );
}

/* Feels Like gradient using exact values from API documentation */
.feels-like-key-gradient {
  background: linear-gradient(to right,
    rgb(80,50,130),   /* -50°F */
    rgb(160,130,190), /* -30°F */
    rgb(110,0,70),    /* -10°F */
    rgb(205,95,200),  /* 10°F */
    rgb(90,120,185),  /* 30°F */
    rgb(25,30,150),   /* 40°F */
    rgb(115,105,100), /* 50°F */
    rgb(0,0,0),       /* 51-79°F */
    rgb(220,40,0),    /* 80°F */
    rgb(245,125,200), /* 100°F */
    rgb(240,20,110)   /* 120°F */
  );
} `, "",{"version":3,"sources":["webpack://./src/components/MapLayerToolbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA,uCAAuC;AACvC;EACE,WAAW,EAAE,kBAAkB;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc,EAAE,iCAAiC;AACnD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,mEAAmE;AACnE,4CAA4C,+BAA+B,EAAE,EAAE,UAAU;AACzF,4CAA4C,gCAAgC,EAAE,EAAE,UAAU;AAC1F,4CAA4C,kCAAkC,EAAE,EAAE,UAAU;AAC5F,4CAA4C,+BAA+B,EAAE,EAAE,UAAU;AACzF,4CAA4C,iCAAiC,EAAE,EAAE,QAAQ;AACzF,4CAA4C,iCAAiC,EAAE,EAAE,SAAS;AAC1F,4CAA4C,kCAAkC,EAAE,EAAE,SAAS;AAC3F,4CAA4C,kCAAkC,EAAE,EAAE,SAAS;AAC3F,4CAA4C,gCAAgC,EAAE,EAAE,SAAS;AACzF,6CAA6C,kCAAkC,EAAE,EAAE,SAAS;AAC5F,6CAA6C,iCAAiC,EAAE,EAAE,SAAS;AAC3F,6CAA6C,gCAAgC,EAAE,EAAE,SAAS;AAC1F,6CAA6C,+BAA+B,EAAE,EAAE,SAAS;AACzF,6CAA6C,8BAA8B,EAAE,EAAE,SAAS;AACxF,6CAA6C,kCAAkC,EAAE,EAAE,UAAU;AAC7F,6CAA6C,kCAAkC,EAAE,EAAE,UAAU;AAC7F,6CAA6C,kCAAkC,EAAE,EAAE,UAAU;AAC7F,6CAA6C,kCAAkC,EAAE,EAAE,UAAU;;AAE7F,qEAAqE;AACrE,gDAAgD,gCAAgC,EAAE,EAAE,SAAS;AAC7F,gDAAgD,gCAAgC,EAAE,EAAE,SAAS;AAC7F,gDAAgD,iCAAiC,EAAE,EAAE,OAAO;AAC5F,gDAAgD,iCAAiC,EAAE,EAAE,QAAQ;AAC7F,gDAAgD,8BAA8B,EAAE,EAAE,QAAQ;AAC1F,gDAAgD,8BAA8B,EAAE,EAAE,QAAQ;AAC1F,gDAAgD,6BAA6B,EAAE,EAAE,SAAS;;AAE1F,oBAAoB;AACpB,4CAA4C,yBAAyB,EAAE,EAAE,wBAAwB;AACjG,4CAA4C,yBAAyB,EAAE,EAAE,uBAAuB;AAChG,4CAA4C,yBAAyB,EAAE,EAAE,0BAA0B;AACnG,4CAA4C,yBAAyB,EAAE,EAAE,0BAA0B;AACnG,4CAA4C,yBAAyB,EAAE,EAAE,gBAAgB;AACzF,4CAA4C,yBAAyB,EAAE,EAAE,qBAAqB;AAC9F,4CAA4C,yBAAyB,EAAE,EAAE,mBAAmB;;AAE5F,oBAAoB;AACpB,4CAA4C,yBAAyB,EAAE;AACvE,4CAA4C,yBAAyB,EAAE;AACvE,4CAA4C,yBAAyB,EAAE;AACvE,4CAA4C,yBAAyB,EAAE;AACvE,4CAA4C,yBAAyB,EAAE;AACvE,4CAA4C,yBAAyB,EAAE;AACvE,4CAA4C,yBAAyB,EAAE;;AAEvE,wFAAwF;AACxF,4CAA4C,iCAAiC,EAAE,EAAE,WAAW;AAC5F,4CAA4C,iCAAiC,EAAE,EAAE,WAAW;AAC5F,4CAA4C,+BAA+B,EAAE,EAAE,WAAW;AAC1F,4CAA4C,6BAA6B,EAAE,EAAE,WAAW;AACxF,4CAA4C,iCAAiC,EAAE,EAAE,WAAW;AAC5F,4CAA4C,gCAAgC,EAAE,EAAE,YAAY;;AAE5F,oCAAoC;AACpC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC,wDAAwD,OAAO,EAAE,wBAAwB,EAAE;AAC3F,wDAAwD,SAAS,EAAE,2BAA2B,EAAE;AAChG,wDAAwD,SAAS,EAAE,2BAA2B,EAAE;AAChG,wDAAwD,SAAS,EAAE,2BAA2B,EAAE;AAChG,wDAAwD,SAAS,EAAE,2BAA2B,EAAE;AAChG,wDAAwD,UAAU,EAAE,4BAA4B,EAAE;;AAElG,+CAA+C;AAC/C;EACE;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,8DAA8D;AAC9D,0CAA0C,+BAA+B,EAAE,EAAE,QAAQ;AACrF,0CAA0C,kCAAkC,EAAE,EAAE,MAAM;AACtF,0CAA0C,kCAAkC,EAAE,EAAE,MAAM;AACtF,0CAA0C,iCAAiC,EAAE,EAAE,MAAM;AACrF,0CAA0C,iCAAiC,EAAE,EAAE,MAAM;AACrF,0CAA0C,iCAAiC,EAAE,EAAE,MAAM;AACrF,0CAA0C,iCAAiC,EAAE,EAAE,MAAM;AACrF,0CAA0C,gCAAgC,EAAE,EAAE,MAAM;AACpF,0CAA0C,gCAAgC,EAAE,EAAE,OAAO;AACrF,2CAA2C,iCAAiC,EAAE,EAAE,OAAO;;AAEvF,kCAAkC;AAClC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C,wDAAwD,QAAQ,EAAE,wBAAwB,EAAE,EAAE,SAAS;AACvG,wDAAwD,WAAW,EAAE,2BAA2B,EAAE,EAAE,SAAS;AAC7G,wDAAwD,WAAW,EAAE,2BAA2B,EAAE,EAAE,SAAS;AAC7G,wDAAwD,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAC5G,wDAAwD,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAC5G,wDAAwD,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAC5G,wDAAwD,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAC5G,wDAAwD,WAAW,EAAE,2BAA2B,EAAE,EAAE,SAAS;AAC7G,wDAAwD,UAAU,EAAE,4BAA4B,EAAE,EAAE,SAAS;;AAE7G,oCAAoC;AACpC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD,8DAA8D,QAAQ,EAAE,wBAAwB,EAAE,EAAE,SAAS;AAC7G,8DAA8D,WAAW,EAAE,2BAA2B,EAAE,EAAE,SAAS;AACnH,8DAA8D,WAAW,EAAE,2BAA2B,EAAE,EAAE,SAAS;AACnH,8DAA8D,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAClH,8DAA8D,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAClH,8DAA8D,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAClH,8DAA8D,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAClH,8DAA8D,WAAW,EAAE,2BAA2B,EAAE,EAAE,QAAQ;AAClH,8DAA8D,WAAW,EAAE,2BAA2B,EAAE,EAAE,SAAS;AACnH,+DAA+D,UAAU,EAAE,4BAA4B,EAAE,EAAE,SAAS;;AAEpH,kEAAkE;AAClE,kDAAkD,gCAAgC,EAAE,EAAE,UAAU;AAChG,kDAAkD,kCAAkC,EAAE,EAAE,UAAU;AAClG,kDAAkD,+BAA+B,EAAE,EAAE,UAAU;AAC/F,kDAAkD,iCAAiC,EAAE,EAAE,SAAS;AAChG,kDAAkD,iCAAiC,EAAE,EAAE,SAAS;AAChG,kDAAkD,gCAAgC,EAAE,EAAE,SAAS;AAC/F,kDAAkD,kCAAkC,EAAE,EAAE,SAAS;AACjG,kDAAkD,4BAA4B,EAAE,EAAE,YAAY;AAC9F,kDAAkD,+BAA+B,EAAE,EAAE,SAAS;AAC9F,mDAAmD,kCAAkC,EAAE,EAAE,UAAU;AACnG,mDAAmD,iCAAiC,EAAE,EAAE,UAAU;;AAElG,kDAAkD;AAClD;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sHAAsH;AACxH;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,wCAAwC;AACxC;;;;;;;EAOE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE;;;;;;;;;;;;;;;;;;;GAmBC;AACH;;AAEA,iEAAiE;AACjE;EACE;;;;;;;;GAQC;AACH;;AAEA,sBAAsB;AACtB;EACE;;;;;;;;GAQC;AACH;;AAEA,sBAAsB;AACtB;EACE;;;;;;;;GAQC;AACH;;AAEA,kEAAkE;AAClE;EACE;;;;;;;GAOC;AACH;;AAEA,8DAA8D;AAC9D;EACE;;;;;;;;;;;GAWC;AACH;;AAEA,kEAAkE;AAClE;EACE;;;;;;;;;;;;GAYC;AACH","sourcesContent":[".map-layer-toolbar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  z-index: 999;\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 10px;\n  font-size: 14px;\n  align-items: center;\n  pointer-events: none;\n}\n\n.map-layer-name {\n  font-weight: 500;\n  padding: 2px 0;\n}\n\n.map-layer-key {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(0, 0, 0, 0.3);\n}\n\n/* Thin scrollbar for WebKit browsers */\n.map-layer-key::-webkit-scrollbar {\n  height: 4px; /* Adjust height */\n}\n\n.map-layer-key::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.map-layer-key::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.key-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-left: 10px;\n  font-size: 12px;\n  flex-shrink: 0; /* Prevent items from shrinking */\n}\n\n.key-item.temp-item {\n  width: 270px;\n}\n\n.color-bar-container {\n  display: flex;\n  height: 8px;\n  width: 150px;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.temp-key.color-bar-container {\n  width: 270px;\n  height: 8px;\n}\n\n.color-bar-segment {\n  flex: 1;\n  height: 100%;\n}\n\n.key-labels {\n  display: flex;\n  width: 150px;\n  justify-content: space-between;\n  font-size: 10px;\n  margin-top: 2px;\n  position: relative;\n}\n\n/* Temperature scale labels */\n.temp-key-labels {\n  display: flex;\n  width: 270px;\n  justify-content: space-between;\n  font-size: 9px;\n  margin-top: 2px;\n}\n\n.temp-label {\n  transform: translateX(-50%);\n  position: relative;\n  white-space: nowrap;\n}\n\n/* Dew point specific adjustments */\n.dewpoint-key.color-bar-container {\n  width: 150px;\n}\n\n.dewpoint-key + .temp-key-labels {\n  width: 150px;\n}\n\n/* Temperature colors - using exact values from API documentation */\n.temp-key .color-bar-segment:nth-child(1) { background-color: rgb(40,10,70); } /* -70°F */\n.temp-key .color-bar-segment:nth-child(2) { background-color: rgb(80,50,130); } /* -50°F */\n.temp-key .color-bar-segment:nth-child(3) { background-color: rgb(160,130,190); } /* -30°F */\n.temp-key .color-bar-segment:nth-child(4) { background-color: rgb(110,0,70); } /* -10°F */\n.temp-key .color-bar-segment:nth-child(5) { background-color: rgb(160,50,140); } /* 0°F */\n.temp-key .color-bar-segment:nth-child(6) { background-color: rgb(205,95,200); } /* 10°F */\n.temp-key .color-bar-segment:nth-child(7) { background-color: rgb(170,225,250); } /* 20°F */\n.temp-key .color-bar-segment:nth-child(8) { background-color: rgb(100,125,190); } /* 30°F */\n.temp-key .color-bar-segment:nth-child(9) { background-color: rgb(20,20,150); } /* 40°F */\n.temp-key .color-bar-segment:nth-child(10) { background-color: rgb(115,105,100); } /* 50°F */\n.temp-key .color-bar-segment:nth-child(11) { background-color: rgb(215,215,50); } /* 60°F */\n.temp-key .color-bar-segment:nth-child(12) { background-color: rgb(220,150,0); } /* 70°F */\n.temp-key .color-bar-segment:nth-child(13) { background-color: rgb(220,40,0); } /* 80°F */\n.temp-key .color-bar-segment:nth-child(14) { background-color: rgb(150,0,0); } /* 90°F */\n.temp-key .color-bar-segment:nth-child(15) { background-color: rgb(245,125,200); } /* 100°F */\n.temp-key .color-bar-segment:nth-child(16) { background-color: rgb(210,210,210); } /* 110°F */\n.temp-key .color-bar-segment:nth-child(17) { background-color: rgb(240,240,175); } /* 120°F */\n.temp-key .color-bar-segment:nth-child(18) { background-color: rgb(255,255,255); } /* 130°F */\n\n/* Dew Point key colors - using exact values from API documentation */\n.dewpoint-key .color-bar-segment:nth-child(1) { background-color: rgb(255,175,0); } /* -40° */\n.dewpoint-key .color-bar-segment:nth-child(2) { background-color: rgb(255,245,0); } /* -20° */\n.dewpoint-key .color-bar-segment:nth-child(3) { background-color: rgb(215,210,55); } /* 0° */\n.dewpoint-key .color-bar-segment:nth-child(4) { background-color: rgb(175,190,85); } /* 20° */\n.dewpoint-key .color-bar-segment:nth-child(5) { background-color: rgb(0,255,0); } /* 40° */\n.dewpoint-key .color-bar-segment:nth-child(6) { background-color: rgb(0,175,0); } /* 60° */\n.dewpoint-key .color-bar-segment:nth-child(7) { background-color: rgb(0,60,0); } /* 80+° */\n\n/* Rain key colors */\n.rain-key .color-bar-segment:nth-child(1) { background-color: #63EB63; } /* Light - light green */\n.rain-key .color-bar-segment:nth-child(2) { background-color: #1C9E34; } /* Light - dark green */\n.rain-key .color-bar-segment:nth-child(3) { background-color: #FBEB02; } /* Light-Medium - yellow */\n.rain-key .color-bar-segment:nth-child(4) { background-color: #EE6D02; } /* Medium-Heavy - orange */\n.rain-key .color-bar-segment:nth-child(5) { background-color: #D20B06; } /* Heavy - red */\n.rain-key .color-bar-segment:nth-child(6) { background-color: #A90503; } /* Heavy - dark red */\n.rain-key .color-bar-segment:nth-child(7) { background-color: #800000; } /* Heavy - maroon */\n\n/* Snow key colors */\n.snow-key .color-bar-segment:nth-child(1) { background-color: #B7E9ED; }\n.snow-key .color-bar-segment:nth-child(2) { background-color: #A5DBED; }\n.snow-key .color-bar-segment:nth-child(3) { background-color: #88B6F7; }\n.snow-key .color-bar-segment:nth-child(4) { background-color: #8F84F4; }\n.snow-key .color-bar-segment:nth-child(5) { background-color: #A259DF; }\n.snow-key .color-bar-segment:nth-child(6) { background-color: #C546C8; }\n.snow-key .color-bar-segment:nth-child(7) { background-color: #E650B1; }\n\n/* Wind speed colors - using exact values from API documentation with 10mph increments */\n.wind-key .color-bar-segment:nth-child(1) { background-color: rgb(70,210,255); } /* 10 mph */\n.wind-key .color-bar-segment:nth-child(2) { background-color: rgb(25,120,255); } /* 20 mph */\n.wind-key .color-bar-segment:nth-child(3) { background-color: rgb(0,50,170); } /* 30 mph */\n.wind-key .color-bar-segment:nth-child(4) { background-color: rgb(0,0,90); } /* 40 mph */\n.wind-key .color-bar-segment:nth-child(5) { background-color: rgb(100,15,150); } /* 50 mph */\n.wind-key .color-bar-segment:nth-child(6) { background-color: rgb(165,0,100); } /* 60+ mph */\n\n/* Wind speed specific adjustments */\n.wind-key.color-bar-container {\n  width: 180px;\n}\n\n.wind-key + .temp-key-labels {\n  width: 180px;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 4px;\n  position: relative;\n}\n\n.wind-key + .temp-key-labels .temp-label {\n  position: absolute;\n  font-size: 9px;\n  text-align: center;\n  transform: translateX(-50%);\n}\n\n/* Position each label precisely */\n.wind-key + .temp-key-labels .temp-label:nth-child(1) { left: 0; transform: translateX(0); }\n.wind-key + .temp-key-labels .temp-label:nth-child(2) { left: 20%; transform: translateX(-50%); }\n.wind-key + .temp-key-labels .temp-label:nth-child(3) { left: 40%; transform: translateX(-50%); }\n.wind-key + .temp-key-labels .temp-label:nth-child(4) { left: 60%; transform: translateX(-50%); }\n.wind-key + .temp-key-labels .temp-label:nth-child(5) { left: 80%; transform: translateX(-50%); }\n.wind-key + .temp-key-labels .temp-label:nth-child(6) { left: 100%; transform: translateX(-100%); }\n\n/* Adjust wind key container width for mobile */\n@media (max-width: 768px) {\n  .wind-key.color-bar-container,\n  .wind-key + .temp-key-labels {\n    width: 100%;\n    max-width: 180px;\n  }\n}\n\n/* UV key colors - using exact values from API documentation */\n.uv-key .color-bar-segment:nth-child(1) { background-color: rgb(90,85,80); } /* 1-2 */\n.uv-key .color-bar-segment:nth-child(2) { background-color: rgb(120,120,115); } /* 3 */\n.uv-key .color-bar-segment:nth-child(3) { background-color: rgb(150,150,150); } /* 4 */\n.uv-key .color-bar-segment:nth-child(4) { background-color: rgb(140,110,90); } /* 5 */\n.uv-key .color-bar-segment:nth-child(5) { background-color: rgb(190,175,80); } /* 6 */\n.uv-key .color-bar-segment:nth-child(6) { background-color: rgb(240,240,63); } /* 7 */\n.uv-key .color-bar-segment:nth-child(7) { background-color: rgb(220,135,20); } /* 8 */\n.uv-key .color-bar-segment:nth-child(8) { background-color: rgb(220,75,15); } /* 9 */\n.uv-key .color-bar-segment:nth-child(9) { background-color: rgb(220,15,15); } /* 10 */\n.uv-key .color-bar-segment:nth-child(10) { background-color: rgb(215,65,140); } /* 11 */\n\n/* UV index specific adjustments */\n.uv-key.color-bar-container {\n  width: 200px;\n}\n\n.uv-key + .temp-key-labels {\n  width: 200px;\n  justify-content: space-between;\n  padding: 0 5px;\n  margin-top: 4px;\n}\n\n.uv-key + .temp-key-labels .temp-label {\n  transform: translateX(-50%);\n  font-size: 9px;\n  text-align: center;\n  position: relative;\n}\n\n.uv-key + .temp-key-labels .temp-label:first-child {\n  transform: translateX(0);\n}\n\n.uv-key + .temp-key-labels .temp-label:last-child {\n  transform: translateX(-100%);\n}\n\n/* Adjust UV key container width for mobile */\n@media (max-width: 768px) {\n  .map-layer-toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .map-layer-key {\n    margin-top: 5px;\n    width: 100%;\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    padding-bottom: 8px;\n  }\n  \n  .key-item.temp-item {\n    width: 100%;\n    max-width: 270px;\n  }\n  \n  .temp-key.color-bar-container {\n    width: 100%;\n    max-width: 270px;\n  }\n  \n  .temp-key-labels {\n    width: 100%;\n    max-width: 270px;\n    font-size: 7px;\n  }\n  \n  .uv-key.color-bar-container,\n  .uv-key + .temp-key-labels {\n    width: 100%;\n    max-width: 200px;\n  }\n}\n\n/* Temperature scale labels positioning */\n.temp-key + .temp-key-labels {\n  width: 270px;\n  position: relative;\n  height: 16px;\n  margin-top: 4px;\n}\n\n.temp-key + .temp-key-labels .temp-label {\n  position: absolute;\n  font-size: 9px;\n  text-align: center;\n  transform: translateX(-50%);\n}\n\n/* Position each temperature label precisely */\n.temp-key + .temp-key-labels .temp-label:nth-child(1) { left: 0%; transform: translateX(0); } /* -70° */\n.temp-key + .temp-key-labels .temp-label:nth-child(2) { left: 11.1%; transform: translateX(-50%); } /* -30° */\n.temp-key + .temp-key-labels .temp-label:nth-child(3) { left: 22.2%; transform: translateX(-50%); } /* -10° */\n.temp-key + .temp-key-labels .temp-label:nth-child(4) { left: 33.3%; transform: translateX(-50%); } /* 20° */\n.temp-key + .temp-key-labels .temp-label:nth-child(5) { left: 44.4%; transform: translateX(-50%); } /* 40° */\n.temp-key + .temp-key-labels .temp-label:nth-child(6) { left: 55.5%; transform: translateX(-50%); } /* 60° */\n.temp-key + .temp-key-labels .temp-label:nth-child(7) { left: 66.6%; transform: translateX(-50%); } /* 80° */\n.temp-key + .temp-key-labels .temp-label:nth-child(8) { left: 77.7%; transform: translateX(-50%); } /* 100° */\n.temp-key + .temp-key-labels .temp-label:nth-child(9) { left: 100%; transform: translateX(-100%); } /* 130° */\n\n/* Feels Like specific adjustments */\n.feels-like-key.color-bar-container {\n  width: 270px;\n}\n\n.feels-like-key + .temp-key-labels {\n  width: 270px;\n  position: relative;\n  height: 16px;\n  margin-top: 4px;\n}\n\n.feels-like-key + .temp-key-labels .temp-label {\n  position: absolute;\n  font-size: 9px;\n  text-align: center;\n  transform: translateX(-50%);\n}\n\n/* Position each feels like temperature label precisely */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(1) { left: 0%; transform: translateX(0); } /* -50° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(2) { left: 11.1%; transform: translateX(-50%); } /* -30° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(3) { left: 22.2%; transform: translateX(-50%); } /* -10° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(4) { left: 33.3%; transform: translateX(-50%); } /* 10° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(5) { left: 44.4%; transform: translateX(-50%); } /* 30° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(6) { left: 55.5%; transform: translateX(-50%); } /* 40° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(7) { left: 66.6%; transform: translateX(-50%); } /* 50° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(8) { left: 77.7%; transform: translateX(-50%); } /* 80° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(9) { left: 88.8%; transform: translateX(-50%); } /* 100° */\n.feels-like-key + .temp-key-labels .temp-label:nth-child(10) { left: 100%; transform: translateX(-100%); } /* 120° */\n\n/* Feels Like colors - using exact values from API documentation */\n.feels-like-key .color-bar-segment:nth-child(1) { background-color: rgb(80,50,130); } /* -50°F */\n.feels-like-key .color-bar-segment:nth-child(2) { background-color: rgb(160,130,190); } /* -30°F */\n.feels-like-key .color-bar-segment:nth-child(3) { background-color: rgb(110,0,70); } /* -10°F */\n.feels-like-key .color-bar-segment:nth-child(4) { background-color: rgb(205,95,200); } /* 10°F */\n.feels-like-key .color-bar-segment:nth-child(5) { background-color: rgb(90,120,185); } /* 30°F */\n.feels-like-key .color-bar-segment:nth-child(6) { background-color: rgb(25,30,150); } /* 40°F */\n.feels-like-key .color-bar-segment:nth-child(7) { background-color: rgb(115,105,100); } /* 50°F */\n.feels-like-key .color-bar-segment:nth-child(8) { background-color: rgb(0,0,0); } /* 51-79°F */\n.feels-like-key .color-bar-segment:nth-child(9) { background-color: rgb(220,40,0); } /* 80°F */\n.feels-like-key .color-bar-segment:nth-child(10) { background-color: rgb(245,125,200); } /* 100°F */\n.feels-like-key .color-bar-segment:nth-child(11) { background-color: rgb(240,20,110); } /* 120°F */\n\n/* Multi-key for radar display (Rain, Mix, Snow) */\n.multi-key.color-bar-container {\n  display: flex;\n  gap: 20px;\n  width: 400px;\n  height: auto;\n}\n\n.multi-key-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.key-type-label {\n  font-size: 10px;\n  margin-bottom: 2px;\n  font-weight: 500;\n}\n\n.rain-key-segment, .mix-key-segment, .snow-key-segment {\n  width: 100%;\n  height: 8px;\n  border-radius: 2px;\n}\n\n.rain-key-segment {\n  background: linear-gradient(to right, #63EB63, #1C9E34, #FBEB02, #EE6D02, #D20B06, #A90503, #800000, #D2449C, #FFFFFF);\n}\n\n.mix-key-segment {\n  background: linear-gradient(to right, #FFA0CF, #D96EA3, #C04D86, #AE3370, #830D4F);\n}\n\n.snow-key-segment {\n  background: linear-gradient(to right, #8AF8FF, #6ECBD4, #529FAA, #44899A, #285D68, #0D3140);\n}\n\n.intensity-labels {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 9px;\n  margin-top: 2px;\n}\n\n.light-label {\n  text-align: left;\n}\n\n.heavy-label {\n  text-align: right;\n}\n\n.key-item.multi-item {\n  width: 400px;\n}\n\n/* Adjust for mobile */\n@media (max-width: 768px) {\n  .multi-key.color-bar-container {\n    width: 100%;\n    max-width: 400px;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.3) rgba(0, 0, 0, 0.3);\n    gap: 10px;\n  }\n  \n  .multi-key.color-bar-container::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  .multi-key.color-bar-container::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.3);\n  }\n\n  .multi-key.color-bar-container::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.3);\n    border-radius: 2px;\n  }\n  \n  .key-item.multi-item {\n    width: 100%;\n    max-width: 400px;\n  }\n  \n  .multi-key-group {\n    width: 100%;\n  }\n}\n\n/* Common styles for all gradient keys */\n.temp-key-gradient, \n.dewpoint-key-gradient, \n.rain-key-gradient, \n.snow-key-gradient, \n.wind-key-gradient, \n.uv-key-gradient,\n.feels-like-key-gradient {\n  width: 100%;\n  height: 8px;\n  border-radius: 2px;\n}\n\n/* Temperature gradient using exact colors from API documentation */\n.temp-key-gradient {\n  background: linear-gradient(to right,\n    rgb(40,10,70),    /* -70°F */\n    rgb(80,50,130),   /* -50°F */\n    rgb(160,130,190), /* -30°F */\n    rgb(110,0,70),    /* -10°F */\n    rgb(160,50,140),  /* 0°F */\n    rgb(205,95,200),  /* 10°F */\n    rgb(170,225,250), /* 20°F */\n    rgb(100,125,190), /* 30°F */\n    rgb(20,20,150),   /* 40°F */\n    rgb(115,105,100), /* 50°F */\n    rgb(215,215,50),  /* 60°F */\n    rgb(220,150,0),   /* 70°F */\n    rgb(220,40,0),    /* 80°F */\n    rgb(150,0,0),     /* 90°F */\n    rgb(245,125,200), /* 100°F */\n    rgb(210,210,210), /* 110°F */\n    rgb(240,240,175), /* 120°F */\n    rgb(255,255,255)  /* 130°F */\n  );\n}\n\n/* Dew Point gradient using exact values from API documentation */\n.dewpoint-key-gradient {\n  background: linear-gradient(to right,\n    rgb(255,175,0),  /* -40° */\n    rgb(255,245,0),  /* -20° */\n    rgb(215,210,55), /* 0° */\n    rgb(175,190,85), /* 20° */\n    rgb(0,255,0),    /* 40° */\n    rgb(0,175,0),    /* 60° */\n    rgb(0,60,0)      /* 80+° */\n  );\n}\n\n/* Rain key gradient */\n.rain-key-gradient {\n  background: linear-gradient(to right, \n    #C1E6D0, \n    #7FD67F, \n    #FFE978, \n    #FFC140, \n    #FF9A3C, \n    #FF6E3C, \n    #F55A90\n  );\n}\n\n/* Snow key gradient */\n.snow-key-gradient {\n  background: linear-gradient(to right,\n    #B7E9ED,\n    #A5DBED,\n    #88B6F7,\n    #8F84F4,\n    #A259DF,\n    #C546C8,\n    #E650B1\n  );\n}\n\n/* Wind speed gradient using exact values from API documentation */\n.wind-key-gradient {\n  background: linear-gradient(to right,\n    rgb(70,210,255),  /* 10 mph */\n    rgb(25,120,255),  /* 20 mph */\n    rgb(0,50,170),    /* 30 mph */\n    rgb(0,0,90),      /* 40 mph */\n    rgb(100,15,150),  /* 50 mph */\n    rgb(165,0,100)    /* 60+ mph */\n  );\n}\n\n/* UV key gradient using exact values from API documentation */\n.uv-key-gradient {\n  background: linear-gradient(to right,\n    rgb(90,85,80),    /* 1-2 */\n    rgb(120,120,115), /* 3 */\n    rgb(150,150,150), /* 4 */\n    rgb(140,110,90),  /* 5 */\n    rgb(190,175,80),  /* 6 */\n    rgb(240,240,63),  /* 7 */\n    rgb(220,135,20),  /* 8 */\n    rgb(220,75,15),   /* 9 */\n    rgb(220,15,15),   /* 10 */\n    rgb(215,65,140)   /* 11 */\n  );\n}\n\n/* Feels Like gradient using exact values from API documentation */\n.feels-like-key-gradient {\n  background: linear-gradient(to right,\n    rgb(80,50,130),   /* -50°F */\n    rgb(160,130,190), /* -30°F */\n    rgb(110,0,70),    /* -10°F */\n    rgb(205,95,200),  /* 10°F */\n    rgb(90,120,185),  /* 30°F */\n    rgb(25,30,150),   /* 40°F */\n    rgb(115,105,100), /* 50°F */\n    rgb(0,0,0),       /* 51-79°F */\n    rgb(220,40,0),    /* 80°F */\n    rgb(245,125,200), /* 100°F */\n    rgb(240,20,110)   /* 120°F */\n  );\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
